'use client';

import { lib } from '@/lib';
import { useEffect } from 'react';

interface Props {
  force?: boolean;
}

export default function ErudaLoader(props: Props) {
  const { force = false } = props;

  useEffect(() => {
    if (!force && process.env.NEXT_PUBLIC_ENABLE_GLOBAL_ERUDA !== '1') {
      console.log('ErudaLoader: not loading eruda, force:', force);
      return;
    }

    if (typeof window === 'undefined') {
      console.log('ErudaLoader: window is undefined, skipping eruda loading');
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).eruda) {
      console.log('ErudaLoader: eruda already loaded');
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/eruda';
    script.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).eruda.init();
    };
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [force]);

  return null;
}
